import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconCross({ color = '#000000', title, ...rest }: IconProps): ReactElement {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' {...rest} xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <g fill='none' fillRule='evenodd'>
                <g transform='translate(5 5)' fill={color} fillRule='nonzero'>
                    <path d='M-0.707106781,0.707106781 C-1.09763107,0.316582489 -1.09763107,-0.316582489 -0.707106781,-0.707106781 C-0.316582489,-1.09763107 0.316582489,-1.09763107 0.707106781,-0.707106781 L14.8492424,13.4350288 C15.2397667,13.8255531 15.2397667,14.4587181 14.8492424,14.8492424 C14.4587181,15.2397667 13.8255531,15.2397667 13.4350288,14.8492424 L-0.707106781,0.707106781 Z' />
                    <path d='M13.2928932,-0.707106781 C13.6834175,-1.09763107 14.3165825,-1.09763107 14.7071068,-0.707106781 C15.0976311,-0.316582489 15.0976311,0.316582489 14.7071068,0.707106781 L0.707106781,14.7071068 C0.316582489,15.0976311 -0.316582489,15.0976311 -0.707106781,14.7071068 C-1.09763107,14.3165825 -1.09763107,13.6834175 -0.707106781,13.2928932 L13.2928932,-0.707106781 Z' />
                </g>
            </g>
        </svg>
    );
}
